import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import About from "./components/About";
import Expertise from "./components/Expertise";
import Values from "./components/Values";
import Statement from "./components/Statement";
import Contact from "./components/Contact";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Expertise />
        <Values />
        <Statement />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}